export const storedData = [
  {
    accepted: true,
    isWhatsapp: true,
    _id: '5e8cfedf33ec930013b2ddbe',
    title: 'TRC Materiais de Con',
    category: 'Outros 🛠',
    placeOptions:
      'Reserva/Envio ,Virtual/Online ,Entrega e Retirada ,Atendimento na loja',
    workingTime: 'Seg, Ter, Qua, Qui, Sex, Sab',
    description: 'Aberto e entrega em até 24h dependendo da região.',
    website: 'https://www.trcacabamentos.store/',
    phone: '(47) 99952-1124',
    latitude: -26.848835362933293,
    longitude: -49.08167605025567,
    createdAt: '2020-04-07T22:29:51.402Z',
    updatedAt: '2020-04-07T22:41:49.753Z',
    __v: 0,
  },
  {
    accepted: true,
    isWhatsapp: false,
    _id: '5e8cff1a33ec930013b2ddbf',
    title: 'Urban Pet',
    category: 'Pets 🐶',
    placeOptions:
      'Retirada(drive-thru) ,Entrega e Retirada ,Atendimento na loja',
    workingTime: 'Seg, Ter, Qua, Qui, Sex, Sab',
    description: 'local para tosar, banhar pets, venda de ração e acessorios',
    website: '',
    phone: '(81) 37715-971_',
    latitude: -8.00597076394779,
    longitude: -34.84102386550386,
    createdAt: '2020-04-07T22:30:51.000Z',
    updatedAt: '2020-04-07T22:45:36.937Z',
    __v: 0,
  },
  {
    accepted: true,
    isWhatsapp: false,
    _id: '5e8d015b33ec930013b2ddc2',
    title: 'Olinda bichos',
    category: 'Pets 🐶',
    placeOptions: 'Retirada(drive-thru) ,Reserva/Envio ,Atendimento na loja',
    workingTime: 'Seg, Ter, Qua, Qui, Sex, Sab',
    description: 'ração, medicamentos e acessorios para pet',
    website: '',
    phone: '(81) 34943-798_',
    latitude: -8.009346076689313,
    longitude: -34.84236377190854,
    createdAt: '2020-04-07T22:40:27.875Z',
    updatedAt: '2020-04-07T22:46:58.967Z',
    __v: 0,
  },
  {
    accepted: true,
    isWhatsapp: true,
    _id: '5e8d018133ec930013b2ddc3',
    title: 'Maná Delicatessen',
    category: 'Mantimentos 🛒',
    placeOptions: 'Atendimento na loja',
    workingTime: 'Seg, Ter, Qua, Qui, Sex, Sab, Dom',
    description: 'Padaria com bons preços e ótima localização.',
    website: '',
    phone: '(81) 98400-8271',
    latitude: -8.029019469988095,
    longitude: -34.89955186263355,
    createdAt: '2020-04-07T22:41:05.199Z',
    updatedAt: '2020-04-07T22:47:03.716Z',
    __v: 0,
  },
  {
    accepted: true,
    isWhatsapp: false,
    _id: '5e8d030d33ec930013b2ddc4',
    title: 'extra supermercado',
    category: 'Mantimentos 🛒',
    placeOptions: 'Atendimento na loja',
    workingTime: 'Seg, Ter, Qua, Qui, Sex, Sab',
    description: 'mercado que vende tudo',
    website: '',
    phone: '(__) _____-____',
    latitude: -8.007994380480168,
    longitude: -34.84204900409855,
    createdAt: '2020-04-07T22:47:41.351Z',
    updatedAt: '2020-04-07T23:26:37.054Z',
    __v: 0,
  },
  {
    accepted: true,
    isWhatsapp: false,
    _id: '5e8d17cf33ec930013b2ddc8',
    title: 'Mercado Santa Rita',
    category: 'Mantimentos 🛒',
    placeOptions: 'Atendimento na loja',
    workingTime: 'Seg, Ter, Qua, Qui, Sex, Sab',
    description: 'Mercadinho de bairro, super bom, preços bons, açougue top',
    website: '',
    phone: '(__) _____-____',
    latitude: -26.85425065244196,
    longitude: -49.04700753095948,
    createdAt: '2020-04-08T00:16:15.451Z',
    updatedAt: '2020-04-08T00:17:17.649Z',
    __v: 0,
  },
  {
    accepted: true,
    isWhatsapp: true,
    _id: '5e8d189833ec930013b2ddc9',
    title: 'M&Pcar',
    category: 'Outros 🛠',
    placeOptions: 'Atendimento na loja',
    workingTime: 'Seg, Ter, Qua, Qui, Sex, Sab, Dom',
    description: 'Serviços de Arcondicionado e acessorios para automóveis ',
    website: '@paulo_mpcar',
    phone: '(85) 98653-1285',
    latitude: -3.752209229985746,
    longitude: -38.580016234538206,
    createdAt: '2020-04-08T00:19:36.404Z',
    updatedAt: '2020-04-08T00:26:22.711Z',
    __v: 0,
  },
  {
    accepted: true,
    isWhatsapp: true,
    _id: '5e8d199933ec930013b2ddca',
    title: 'Medeiros Burguer',
    category: 'Refeições 🍽',
    placeOptions: 'Retirada(drive-thru) ,Reserva/Envio ,Entrega e Retirada',
    workingTime: 'Seg, Ter, Qui, Sex, Sab, Dom',
    description: 'Tempo mínimo de espera de 30 a 40min.  Molho especial 😋',
    website: '',
    phone: '(81) 98670-9027',
    latitude: -8.038945442409137,
    longitude: -34.87545921302175,
    createdAt: '2020-04-08T00:23:53.848Z',
    updatedAt: '2020-04-08T00:26:36.563Z',
    __v: 0,
  },
  {
    accepted: true,
    isWhatsapp: true,
    _id: '5e8d1a0133ec930013b2ddcb',
    title: 'Medeiros Burguer',
    category: 'Refeições 🍽',
    placeOptions: 'Retirada(drive-thru) ,Reserva/Envio ,Entrega e Retirada',
    workingTime: 'Seg, Ter, Qui, Sex, Sab, Dom',
    description: 'Tempo mínimo de espera de 30 a 40min.  Molho especial 😋',
    website: '',
    phone: '(81) 98670-9027',
    latitude: -8.038945442409137,
    longitude: -34.87545921302175,
    createdAt: '2020-04-08T00:25:37.541Z',
    updatedAt: '2020-04-08T00:27:09.282Z',
    __v: 0,
  },
  {
    accepted: true,
    isWhatsapp: true,
    _id: '5e8d1a7233ec930013b2ddcd',
    title: 'Medeiros Burguer',
    category: 'Refeições 🍽',
    placeOptions: 'Retirada(drive-thru) ,Reserva/Envio ,Entrega e Retirada',
    workingTime: 'Seg, Ter, Qui, Sex, Sab, Dom',
    description: 'Tempo mínimo de espera de 30 a 40min.  Molho especial 😋',
    website: '',
    phone: '(81) 98670-9027',
    latitude: -8.038945442409137,
    longitude: -34.87545921302175,
    createdAt: '2020-04-08T00:27:30.845Z',
    updatedAt: '2020-04-08T01:32:11.661Z',
    __v: 0,
  },
  {
    accepted: true,
    isWhatsapp: false,
    _id: '5e8dfdf033ec930013b2ddce',
    title: 'Panificadora e Confeitaria Mai',
    category: 'Refeições 🍽',
    placeOptions: 'Reserva/Envio ,Atendimento na loja',
    workingTime: 'Seg, Ter, Qua, Qui, Sex, Sab, Dom',
    description: '',
    website: '',
    phone: '(42) 32323-101_',
    latitude: -24.79591272383622,
    longitude: -50.00906198973925,
    createdAt: '2020-04-08T16:38:08.508Z',
    updatedAt: '2020-04-08T20:38:11.543Z',
    __v: 0,
  },
  {
    accepted: true,
    isWhatsapp: true,
    _id: '5e8e252b33ec930013b2ddcf',
    title: 'Krause Material de Construção',
    category: 'Outros 🛠',
    placeOptions:
      'Retirada(drive-thru) ,Reserva/Envio ,Virtual/Online ,Entrega e Retirada ,Atendimento na loja',
    workingTime: 'Seg, Ter, Qua, Qui, Sex, Sab',
    description: 'Entrega em ate 2 dias uteis na região. Outros, consultar.',
    website: '',
    phone: '(27) 99777-5019',
    latitude: -20.304922650443462,
    longitude: -40.36779958325038,
    createdAt: '2020-04-08T19:25:31.538Z',
    updatedAt: '2020-04-08T20:38:16.817Z',
    __v: 0,
  },
  {
    accepted: true,
    isWhatsapp: true,
    _id: '5e8e26a933ec930013b2ddd0',
    title: 'La Rosie',
    category: 'Outros 🛠',
    placeOptions: 'Virtual/Online',
    workingTime: 'Seg, Ter, Qua, Qui, Sex, Sab, Dom',
    description: 'Venda de acessórios femininos e calçados.',
    website: 'www.larosie.com.br',
    phone: '(41) 98870-3076',
    latitude: -25.463659373774128,
    longitude: -49.29040832595319,
    createdAt: '2020-04-08T19:31:53.998Z',
    updatedAt: '2020-04-08T20:38:24.550Z',
    __v: 0,
  },
  {
    accepted: true,
    isWhatsapp: false,
    _id: '5e8e345833ec930013b2ddd1',
    title: 'Mercado Fasan',
    category: 'Mantimentos 🛒',
    placeOptions: 'Entrega e Retirada ,Atendimento na loja',
    workingTime: 'Seg, Ter, Qua, Qui, Sex, Sab, Dom',
    description: 'É um pequeno mercado que possui mantimentos suficientes',
    website: '',
    phone: '(__) _____-____',
    latitude: -23.435637659362616,
    longitude: -51.926802482771585,
    createdAt: '2020-04-08T20:30:16.900Z',
    updatedAt: '2020-04-08T20:38:31.232Z',
    __v: 0,
  },
  {
    accepted: true,
    isWhatsapp: true,
    _id: '5e8e376b33ec930013b2ddd2',
    title: 'FMX Comércio de Vedações Indús',
    category: 'Outros 🛠',
    placeOptions: 'Reserva/Envio ,Entrega e Retirada ,Atendimento na loja',
    workingTime: 'Seg, Ter, Qua, Qui, Sex',
    description: 'Comércio de vedações industriais,  aceita contato via Whats',
    website: 'https://www.fmxvedacoes.com.br/',
    phone: '(16) 97400-1919',
    latitude: -21.182780109368785,
    longitude: -47.817924764799756,
    createdAt: '2020-04-08T20:43:23.813Z',
    updatedAt: '2020-04-08T20:56:06.268Z',
    __v: 0,
  },
  {
    accepted: true,
    isWhatsapp: true,
    _id: '5e8e4cd333ec930013b2ddd3',
    title: 'Agropecuária',
    category: 'Pets 🐶',
    placeOptions: 'Reserva/Envio',
    workingTime: 'Seg, Ter, Qua, Qui, Sex, Sab',
    description: 'Estão entregando ração e outras coisas de pet, pedidos pelo ',
    website: '',
    phone: '(44) 99770-7931',
    latitude: -23.398815937206177,
    longitude: -51.94065558821613,
    createdAt: '2020-04-08T22:14:43.183Z',
    updatedAt: '2020-04-08T22:33:29.846Z',
    __v: 0,
  },
  {
    accepted: true,
    isWhatsapp: true,
    _id: '5e8e64fe33ec930013b2ddd4',
    title: 'Relojoaria e Óptica Carlos',
    category: 'Serviços 💼',
    placeOptions: 'Entrega e Retirada ,Atendimento na loja',
    workingTime: 'Seg, Ter, Qua, Qui, Sex, Sab',
    description: 'Óculos, consertos, etc.',
    website: '@opticacarlosblumenau',
    phone: '(47) 99204-1417',
    latitude: -26.90468723044769,
    longitude: -49.09298467737448,
    createdAt: '2020-04-08T23:57:50.667Z',
    updatedAt: '2020-04-09T12:56:31.096Z',
    __v: 0,
  },
  {
    accepted: true,
    isWhatsapp: false,
    _id: '5e8e6ea933ec930013b2ddd5',
    title: 'Mercado Barbosa ',
    category: 'Mantimentos 🛒',
    placeOptions: 'Atendimento na loja',
    workingTime: 'Seg, Ter, Qua, Qui, Sex, Sab',
    description: 'O atendimento é ótimo. ',
    website: '',
    phone: '(__) _____-____',
    latitude: -23.657021543098647,
    longitude: -46.73295428783322,
    createdAt: '2020-04-09T00:39:05.153Z',
    updatedAt: '2020-04-09T12:56:38.890Z',
    __v: 0,
  },
  {
    accepted: true,
    isWhatsapp: true,
    _id: '5e8ee6f233ec930013b2ddd6',
    title: 'Supermercado Conquista',
    category: 'Mantimentos 🛒',
    placeOptions: 'Virtual/Online ,Entrega e Retirada',
    workingTime: 'Seg, Ter, Qua, Qui, Sex, Sab, Dom',
    description: 'Só pedir pelo whatsapp, eles enviam fotos dos produtos',
    website: '',
    phone: '(64) 98459-0170',
    latitude: -17.428487714507813,
    longitude: -49.65924846257226,
    createdAt: '2020-04-09T09:12:18.979Z',
    updatedAt: '2020-04-09T12:56:45.029Z',
    __v: 0,
  },
  {
    accepted: true,
    isWhatsapp: false,
    _id: '5e8ee75d33ec930013b2ddd7',
    title: 'Supermercado Marques',
    category: 'Mantimentos 🛒',
    placeOptions: 'Entrega e Retirada',
    workingTime: 'Seg, Ter, Qua, Qui, Sex, Sab, Dom',
    description: 'Entregam',
    website: '',
    phone: '(64) 34801-616_',
    latitude: -17.424483112760793,
    longitude: -49.666642613415945,
    createdAt: '2020-04-09T09:14:05.955Z',
    updatedAt: '2020-04-09T12:56:50.845Z',
    __v: 0,
  },
  {
    accepted: true,
    isWhatsapp: false,
    _id: '5e8f1e1233ec930013b2ddd8',
    title: 'Bom Preço Supermercados',
    category: 'Mantimentos 🛒',
    placeOptions: 'Atendimento na loja',
    workingTime: 'Seg, Ter, Qua, Qui, Sex, Sab',
    description: 'Pequeno supermercado aberto para compras na loja e entrega.',
    website: '',
    phone: '(__) _____-____',
    latitude: -20.430850370772188,
    longitude: -51.34716982954038,
    createdAt: '2020-04-09T13:07:30.655Z',
    updatedAt: '2020-04-09T19:08:02.709Z',
    __v: 0,
  },
  {
    accepted: true,
    isWhatsapp: false,
    _id: '5e8f1e7c33ec930013b2ddd9',
    title: 'Casa das Rações',
    category: 'Pets 🐶',
    placeOptions: 'Reserva/Envio',
    workingTime: 'Seg, Ter, Qua, Qui, Sex, Sab',
    description: 'Retirada de rações e etc para animais.',
    website: '',
    phone: '(__) _____-____',
    latitude: -20.4292792712891,
    longitude: -51.346442683395416,
    createdAt: '2020-04-09T13:09:16.962Z',
    updatedAt: '2020-04-09T19:08:36.442Z',
    __v: 0,
  },
  {
    accepted: true,
    isWhatsapp: false,
    _id: '5e8f1efc33ec930013b2ddda',
    title: 'Choperia e Cachaçaria Pimenta',
    category: 'Refeições 🍽',
    placeOptions: 'Retirada(drive-thru) ,Entrega e Retirada',
    workingTime: 'Seg, Ter, Qua, Qui, Sex, Sab, Dom',
    description: 'Tempo de entrega depende do pedido.',
    website: '',
    phone: '(__) _____-____',
    latitude: -20.433981224322427,
    longitude: -51.34974466179307,
    createdAt: '2020-04-09T13:11:24.325Z',
    updatedAt: '2020-04-09T19:08:42.203Z',
    __v: 0,
  },
  {
    accepted: true,
    isWhatsapp: false,
    _id: '5e8f1f3033ec930013b2dddb',
    title: 'Proença Supermercados',
    category: 'Mantimentos 🛒',
    placeOptions: 'Entrega e Retirada ,Atendimento na loja',
    workingTime: 'Seg, Ter, Qua, Qui, Sex, Sab',
    description: 'Supermercado. Opções de atendimento na loja.',
    website: '',
    phone: '(__) _____-____',
    latitude: -20.43523374367453,
    longitude: -51.340705992427765,
    createdAt: '2020-04-09T13:12:16.098Z',
    updatedAt: '2020-04-09T19:08:52.163Z',
    __v: 0,
  },
  {
    accepted: true,
    isWhatsapp: false,
    _id: '5e8f1f5a33ec930013b2dddc',
    title: 'Supermercados Pelachim',
    category: 'Mantimentos 🛒',
    placeOptions: 'Atendimento na loja',
    workingTime: 'Seg, Ter, Qua, Qui, Sex, Sab',
    description: 'Supermercado. Atendimento na loja',
    website: '',
    phone: '(__) _____-____',
    latitude: -20.423413545997462,
    longitude: -51.338447725147795,
    createdAt: '2020-04-09T13:12:58.448Z',
    updatedAt: '2020-04-09T19:08:58.262Z',
    __v: 0,
  },
  {
    accepted: true,
    isWhatsapp: false,
    _id: '5e8f1f8133ec930013b2dddd',
    title: 'Proença Supermercados',
    category: 'Mantimentos 🛒',
    placeOptions: 'Atendimento na loja',
    workingTime: 'Seg, Ter, Qua, Qui, Sex, Sab',
    description: 'Supermercado',
    website: '',
    phone: '(__) _____-____',
    latitude: -20.424258392301947,
    longitude: -51.34031514754894,
    createdAt: '2020-04-09T13:13:37.675Z',
    updatedAt: '2020-04-09T19:09:04.699Z',
    __v: 0,
  },
  {
    accepted: true,
    isWhatsapp: true,
    _id: '5e8f204c33ec930013b2ddde',
    title: 'Comunicação Visual',
    category: 'Serviços 💼',
    placeOptions: 'Virtual/Online ,Atendimento na loja',
    workingTime: 'Seg, Sex',
    description: 'Entrega própria',
    website: '',
    phone: '(54) 99162-8804',
    latitude: -27.64458275020017,
    longitude: -52.25709006875573,
    createdAt: '2020-04-09T13:17:00.605Z',
    updatedAt: '2020-04-09T19:09:17.642Z',
    __v: 0,
  },
  {
    accepted: true,
    isWhatsapp: false,
    _id: '5e91dcc5accc4d0014aa7da6',
    title: 'MERCADO BAZINHO',
    category: 'Mantimentos 🛒',
    placeOptions: 'Entrega e Retirada ,Atendimento na loja',
    workingTime: 'Seg, Ter, Qua, Qui, Sex, Sab',
    description: 'Mercado ',
    website: '',
    phone: '(32) 37225-278_',
    latitude: -21.13031335304325,
    longitude: -42.37662265844422,
    createdAt: '2020-04-11T15:05:41.463Z',
    updatedAt: '2020-04-11T19:02:30.797Z',
    __v: 0,
  },
  {
    accepted: true,
    isWhatsapp: false,
    _id: '5e91dd55accc4d0014aa7da7',
    title: 'Carne & Cia Centro',
    category: 'Refeições 🍽',
    placeOptions: 'Entrega e Retirada',
    workingTime: 'Ter, Qua, Qui, Sex, Sab',
    description: 'Restaurante',
    website: '',
    phone: '(32) 37211-300_',
    latitude: -21.132485092182577,
    longitude: -42.36455327036084,
    createdAt: '2020-04-11T15:08:05.299Z',
    updatedAt: '2020-04-11T19:02:48.866Z',
    __v: 0,
  },
  {
    accepted: true,
    isWhatsapp: false,
    _id: '5e91ddc3accc4d0014aa7da8',
    title: 'Panificadora Toscana',
    category: 'Mantimentos 🛒',
    placeOptions: 'Entrega e Retirada ,Atendimento na loja',
    workingTime: 'Seg, Ter, Qua, Qui, Sex, Sab, Dom',
    description: 'Padaria',
    website: '',
    phone: '(32) 37225-501_',
    latitude: -21.132070494281898,
    longitude: -42.36440158351951,
    createdAt: '2020-04-11T15:09:55.540Z',
    updatedAt: '2020-04-11T19:02:59.718Z',
    __v: 0,
  },
  {
    accepted: true,
    isWhatsapp: false,
    _id: '5e91de09accc4d0014aa7da9',
    title: 'REDE INOVA DROGARIA',
    category: 'Outros 🛠',
    placeOptions: 'Entrega e Retirada ,Atendimento na loja',
    workingTime: 'Seg, Ter, Qua, Qui, Sex, Sab, Dom',
    description: 'Drogaria',
    website: '',
    phone: '(32) 37210-000_',
    latitude: -21.130914570267944,
    longitude: -42.363337214934255,
    createdAt: '2020-04-11T15:11:05.600Z',
    updatedAt: '2020-04-11T19:03:08.193Z',
    __v: 0,
  },
  {
    accepted: true,
    isWhatsapp: false,
    _id: '5e91de5baccc4d0014aa7daa',
    title: 'Drogaria Pague Menos',
    category: 'Outros 🛠',
    placeOptions: 'Entrega e Retirada ,Atendimento na loja',
    workingTime: 'Seg, Ter, Qua, Qui, Sex, Sab, Dom',
    description: 'Drogaria',
    website: '',
    phone: '(32) 37211-067_',
    latitude: -21.131378237779348,
    longitude: -42.36375631430618,
    createdAt: '2020-04-11T15:12:27.562Z',
    updatedAt: '2020-04-11T19:03:16.534Z',
    __v: 0,
  },
  {
    accepted: true,
    isWhatsapp: false,
    _id: '5e91de99accc4d0014aa7dab',
    title: 'Supermercado Levate',
    category: 'Mantimentos 🛒',
    placeOptions: 'Entrega e Retirada ,Atendimento na loja',
    workingTime: 'Seg, Ter, Qua, Qui, Sex, Sab',
    description: 'Supermercado',
    website: '',
    phone: '(32) 37211-666_',
    latitude: -21.13283060542136,
    longitude: -42.36059729809431,
    createdAt: '2020-04-11T15:13:29.636Z',
    updatedAt: '2020-04-11T19:03:22.336Z',
    __v: 0,
  },
  {
    accepted: true,
    isWhatsapp: false,
    _id: '5e91defaaccc4d0014aa7dac',
    title: 'Top Frut',
    category: 'Mantimentos 🛒',
    placeOptions: 'Entrega e Retirada ,Atendimento na loja',
    workingTime: 'Seg, Ter, Qua, Qui, Sex, Sab',
    description: 'Hortifruti',
    website: '',
    phone: '(32) 37225-374_',
    latitude: -21.133006252674317,
    longitude: -42.36095218436435,
    createdAt: '2020-04-11T15:15:06.124Z',
    updatedAt: '2020-04-11T19:03:27.726Z',
    __v: 0,
  },
  {
    accepted: true,
    isWhatsapp: false,
    _id: '5e91df5daccc4d0014aa7dad',
    title: 'Drogasil',
    category: 'Outros 🛠',
    placeOptions: 'Entrega e Retirada ,Atendimento na loja',
    workingTime: 'Seg, Ter, Qua, Qui, Sex, Sab, Dom',
    description: 'drogaria',
    website: '',
    phone: '(32) 37217-645_',
    latitude: -21.130881233860418,
    longitude: -42.364411160275225,
    createdAt: '2020-04-11T15:16:45.265Z',
    updatedAt: '2020-04-11T19:03:34.232Z',
    __v: 0,
  },
  {
    accepted: true,
    isWhatsapp: true,
    _id: '5e95b67eaccc4d0014aa7dae',
    title: 'Skap Car escapamentos e acessó',
    category: 'Outros 🛠',
    placeOptions: 'Reserva/Envio ,Entrega e Retirada ,Atendimento na loja',
    workingTime: 'Seg, Ter, Qua, Qui, Sex, Sab',
    description: 'Trocas de escapamentos em média 20 minutos!!',
    website: '',
    phone: '(54) 99143-4379',
    latitude: -26.91504900059027,
    longitude: -49.078942910034776,
    createdAt: '2020-04-14T13:11:26.772Z',
    updatedAt: '2020-04-15T14:48:27.519Z',
    __v: 0,
  },
  {
    accepted: true,
    isWhatsapp: true,
    _id: '5e973cb16754cd001ade95e5',
    title: 'Link World informatica',
    category: 'Serviços 💼',
    placeOptions: 'Entrega e Retirada ,Atendimento na loja',
    workingTime: 'Seg, Ter, Qua, Qui, Sex, Sab',
    description: 'Concerto e manutenção de computadores e periféricos.',
    website: 'www.linkworld.com.br',
    phone: '(81) 99952-0792',
    latitude: -7.846263564768718,
    longitude: -35.25275566940742,
    createdAt: '2020-04-15T16:56:17.019Z',
    updatedAt: '2020-04-16T14:18:45.684Z',
    __v: 0,
  },
  {
    accepted: true,
    isWhatsapp: false,
    _id: '5e9869946754cd001ade95e6',
    title: 'Nado da Galinha',
    category: 'Mantimentos 🛒',
    placeOptions: 'Entrega e Retirada ,Atendimento na loja',
    workingTime: 'Seg, Ter, Qua, Qui, Sex, Sab, Dom',
    description: 'Venda de frios por um preço justo',
    website: '',
    phone: '(__) _____-____',
    latitude: -8.008349951371024,
    longitude: -34.866358076252396,
    createdAt: '2020-04-16T14:20:04.845Z',
    updatedAt: '2020-04-16T14:20:30.559Z',
    __v: 0,
  },
  {
    accepted: true,
    isWhatsapp: false,
    _id: '5e9a04ca6754cd001ade95e7',
    title: 'Polipneus',
    category: 'Serviços 💼',
    placeOptions: 'Atendimento na loja',
    workingTime: 'Seg, Ter, Qua, Qui, Sex, Sab',
    description: 'Auto center',
    website: '',
    phone: '(47) 33333-030_',
    latitude: -26.891929251914142,
    longitude: -49.24254978132297,
    createdAt: '2020-04-17T19:34:34.766Z',
    updatedAt: '2020-04-20T11:26:58.149Z',
    __v: 0,
  },
];
